module.exports = __webpack_public_path__ + "img/vote_illustration2.eec0a026.png";